import dynamic from 'next/dynamic'
import React, { FC } from 'react'

import { UrgencyBarFactory } from '@Components/CMS/Bar/BarFactory/Bars/Urgency/UrgencyBarFactory'
import { BarProps } from '@Components/CMS/Bar/BarFactory/types'

const DefaultBar = dynamic(() => import('@Components/CMS/Bar/BarFactory/Bars/DefaultBar'))
const ValentinesBar = dynamic(() => import('@Components/CMS/Bar/BarFactory/Bars/ValentinesBar/ValentinesBar'))

export const BarFactory: FC<BarProps> = (props) => {
  // eslint-disable-next-line react/destructuring-assignment
  switch (props.bar.type) {
    case 'urgency':
      return <UrgencyBarFactory {...props} />
    case 'valentines_day':
      return <ValentinesBar {...props} />
    default:
      return <DefaultBar {...props} />
  }
}
